<template>
    <div
        class="w-fit"
        :class="{
            relative: editable,
        }"
    >
        <!-- Semantic plate tokens: solid blue-200 + dark ink in light, accent
             tint + blue-200 initials in dark — identity sits outside the action
             ramp (solid accent = buttons only; see --bg-negative in default.css). -->
        <span
            class="bg-(--avatar-plate-bg) flex items-center justify-center rounded-md font-semibold"
            :class="{
                'h-6 w-6 rounded-sm': size === 'x-small',
                'h-8 w-8 rounded-sm': size === 'smaller',
                'h-10 w-10': size === 'small',
                'h-16 w-16': size === 'medium',
                'h-24 w-24': size === 'large',
            }"
        >
            <p
                class="text-(--avatar-plate-fg) uppercase"
                :class="{
                    'text-xs': size === 'x-small',
                    'text-2xl': size === 'medium',
                    'text-lg': size === 'small',
                    'text-3xl': size === 'large',
                }"
            >
                {{ initialsSetup() }}
            </p>
            <button
                v-if="editable"
                name="edit"
                class="p-xs absolute -right-1 -bottom-1 rounded-md bg-(--surface-highlight)"
                @click="$emit('edit')"
            >
                <i class="i-edit block" />
            </button>
        </span>
    </div>
</template>

<script setup lang="ts">
import { getInitials } from '@/stores/helpers';

defineEmits<{ edit: [] }>();

const props = defineProps({
    firstName: {
        type: String,
        required: true,
    },
    lastName: {
        type: String,
        required: false,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'small',
    },
});

function initialsSetup() {
    if (props.firstName && props.lastName) {
        return getInitials(props.firstName, props.lastName);
    } else if (props.firstName) {
        return getInitials(props.firstName);
    } else {
        return 'XX';
    }
}
</script>
